import React, { memo } from 'react';
import { SMSIcon } from '@rsos/assets/icons';
import { ResultWrapper, PhoneNumber } from '../ConnectedUniversalSearch.styles';

const StyledOutboundSMS = memo(
  ({
    call,
    index,
    mouseCursor,
    formatPhoneWithDashes,
    handleSearchOutboundSMS,
    isInternational,
    maxWidth,
  }) => {
    const callerID = call.callerID;
    return (
      <ResultWrapper
        key={index}
        onClick={() => handleSearchOutboundSMS(callerID)}
        isHovered={mouseCursor === index}
        maxWidth={maxWidth}
      >
        <>
          <SMSIcon width={16} height={16} />
          <PhoneNumber>
            {isInternational ? callerID : formatPhoneWithDashes(callerID)}
          </PhoneNumber>
        </>
      </ResultWrapper>
    );
  },
);
export default StyledOutboundSMS;
